import { ref, computed, watch } from 'vue'
import { defineStore } from 'pinia'
import { StorageSerializers, useStorage, usePreferredColorScheme } from '@vueuse/core'
import { useTheme } from 'vuetify'

export const useThemeStore = defineStore('theme', () => {
	const theme = useStorage('theme', null, undefined, { serializer: StorageSerializers.object })
    const defaultColorScheme = usePreferredColorScheme();
    const defaultSidebarOnlyIcon = false;
    
    if(!theme.value){
        theme.value = {};
    }
    const _theme = useTheme();
    type colorSchemeType = 'light' | 'dark' | '';
	const getColorScheme = computed(() => {
        if(theme.value?.colorScheme){
            return theme.value.colorScheme;
        }
        if(defaultColorScheme.value !== 'light' && defaultColorScheme.value !== 'dark'){
            return 'light';
        }
        return defaultColorScheme.value;
    });
	const getTrueColorScheme = computed(() => {
        return theme.value?.colorScheme ?? '';
        if(theme.value?.colorScheme){
            return theme.value.colorScheme;
        }
        if(defaultColorScheme.value !== 'light' && defaultColorScheme.value !== 'dark'){
            return '';
        }
        return defaultColorScheme.value;
    });
	const isDark = computed(() => {
        return getColorScheme.value == 'dark';
    });
    _theme.global.name.value = getColorScheme.value;
	const setColorScheme = (scheme: colorSchemeType) => {
		theme.value.colorScheme = scheme;
        _theme.global.name.value = getColorScheme.value;
	}

    const getSidebarOnlyIcon = computed(() => {
        return theme.value?.sidebarOnlyIcon ?? defaultSidebarOnlyIcon;
    })

    const setSidebarOnlyIcon = (state: boolean) => {
        theme.value.sidebarOnlyIcon = state;
    }
    
	return { theme, isDark, getColorScheme, getTrueColorScheme, setColorScheme, getSidebarOnlyIcon, setSidebarOnlyIcon }
})